import { STORAGE_KEY } from "@/utils/key.js"

export function read() {
    return localStorage.getItem(STORAGE_KEY)
}

export function save(token) {
    localStorage.setItem(STORAGE_KEY, token)
}

export function clean() {
    localStorage.removeItem(STORAGE_KEY)
}

export default { read, save, clean }